export const API_ERROR_CODE_EADDRINUSE = 'EADDRINUSE'
export const API_ERROR_CODE_EAI_AGAIN = 'EAI_AGAIN'
export const API_ERROR_CODE_ECONNREFUSED = 'ECONNREFUSED'
export const API_ERROR_CODE_ECONNRESET = 'ECONNRESET'
export const API_ERROR_CODE_ENETUNREACH = 'ENETUNREACH'
export const API_ERROR_CODE_ENOTFOUND = 'ENOTFOUND'
export const API_ERROR_CODE_EPIPE = 'EPIPE'
export const API_ERROR_CODE_EPROTO = 'EPROTO'
export const API_ERROR_CODE_ETIMEDOUT = 'ETIMEDOUT'

export const RETRYABLE_STATUS_CODES = new Set([408, 413, 429, 500, 502, 503, 504, 521, 522, 524])
export const RETRYABLE_ERROR_CODES = new Set([
  API_ERROR_CODE_EADDRINUSE,
  API_ERROR_CODE_EAI_AGAIN,
  API_ERROR_CODE_ECONNREFUSED,
  API_ERROR_CODE_ECONNRESET,
  API_ERROR_CODE_ENETUNREACH,
  API_ERROR_CODE_ENOTFOUND,
  API_ERROR_CODE_EPIPE,
  API_ERROR_CODE_EPROTO,
  API_ERROR_CODE_ETIMEDOUT,
])
